import { render } from "./NewPerson.vue?vue&type=template&id=9baeaa7c&scoped=true"
import script from "./NewPerson.vue?vue&type=script&lang=js"
export * from "./NewPerson.vue?vue&type=script&lang=js"

import "./NewPerson.vue?vue&type=style&index=0&id=9baeaa7c&lang=scss&scoped=true"

import exportComponent from "/opt/app-root/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9baeaa7c"]])

export default __exports__